import script from "./DistributorShop.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorShop.vue?vue&type=script&setup=true&lang=js"

import "./DistributorShop.vue?vue&type=style&index=0&id=4cd8cf14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd8cf14"]])

export default __exports__